<template>
  <dv-border-box-10>
    <div class="main">
      <div class="main-header">
        <h3 style="font-size:40px">现场工种</h3>
      </div>
      <div ref="workType" style="width:100%;height:80%"></div>
    </div>
  </dv-border-box-10>
</template>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(47, 79, 79, 0.1);
  position: relative;
  padding-top: 2%;
}
.main-header{
  margin-left: 2%;
  
}
</style>
<script>
// import '../../assets/rem'
import * as echarts from "echarts/core";
import { TooltipComponent, LegendComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);
export default {
  data() {
    return {
      myChart:{},
    };
  },
  methods:{
    changeData(data){
      let option = {
        series:[
          {
            data:data,
          }
        ]
      }
      this.myChart.setOption(option);
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.workType);
    let option = {
      tooltip: {
        trigger: "item",
        formatter:function(unit){
          return unit.name + ":" + unit.value.toLocaleString()+"人"
        },
        textStyle:{
          fontSize:20
        }
      },
      legend: {
        top: "0%",
        orient: "vertical",
        left: "0%",
        textStyle: {
          color: "#fff",
          fontSize:'20'
        },
      },
      series: [
        {
          // name: "现场工种",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: [
          ],
        },
      ],
    };
    this.myChart.setOption(option);
  },
};
</script>
